import {
  // primaryColor,
  container,
  title
} from "assets/jss/material-kit-react.jsx";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-kit-react/customCheckboxRadioSwitch.jsx";

const profilePageStyle = {
  container,
  ...imagesStyle,
  ...customCheckboxRadioSwitch,
  profile: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      // width: "100%", //removing this fixes streched look on firefox
    },
  },
  titleContainer: {
    zIndex: "12",
    color: "#FFFFFF",
    textAlign: "center",
    flexDirection:"column",
    justifyContent:"flex-end",
    alignItems:"center",
    ...container
  },
  followSectCont: {
    textAlign: 'center',
    alignItems:"center",
    ...container,
    "& Button": {
      marginLeft: 15,
      marginRight: 15,
      maxWidth: 100,
    },
  },
  termsContainer: {
    paddingBottom: 50,
    ...container
  },
  editBtn: {
    // TODO make this work when hovering over the text? ...not only btn
    "&:hover": {
      // color: "#11b9ba",
      // NOTE WTF i am importing this directing from other file where its purple
      // but here its blue?????
      // color: primaryColor + "!important",
      color: "#9c27b0",
    },
  },
  swalPicPreview: {
    display: 'none',
    maxWidth: "160px",
    width: "100%",
    margin: "0 auto",
    transform: "translate3d(0, -50%, 0)"
  },
  profPicBtn: {
    margin: "0 auto",
    transform: "translate3d(0, -50%, 0)"
  },
  invisibleBtn: {
    color: 'transparent'
  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: "#999",
    justifyContent: 'column',
    textAlign: "center !important",
    "& Button": {
      alignItems: "center",
      // paddingBotton: "5px",
      // display: none;
    },
  },
  name: {
    marginTop: "-80px",
    verticalAlign: "middle",
    "& Button": {
      alignItems: "center",
      paddingBotton: "5px",
      // display: none;
    },
  },
  toggleEdit: {
    alignItems: "right",
    textAlign: "right",
    verticalAlign: "middle",
  },
  icons: {
    width: "25px",
    height: "25px",
    color: "#858585",
    marginLeft: 12,
  },
  mscoreMobile: {
    alignItems: "center",
    textAlign: "center",
    verticalAlign: "middle",
    display: "flex",
    flexDirection: "column",
    marginTop: 10
  },
  progressBarCont: {
    width: 75,
    height: 75,
  },
  mscoreBgImg: {
    width: 55
  },
  mscoreDivStyle: {
    position: 'absolute',
    height: 150,
    width: 250,
    left: 0,
    top: 50,
    textAlign: 'center',
    display: 'flex',
    // justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  mTopTxtStyle: {
    fontSize: 14,
    // fontFamily: 'American Typewriter, serif',
    // fontFamily: 'Apple Chancery, cursive',
    fontWeight: 600,
    margin: 1
  },
  mUnameTxtStyle1: {
    fontSize: 12,
    // fontFamily: 'Marker Felt, fantasy',
    // fontFamily: 'American Typewriter, serif',
    fontWeight: 600,
    margin: 0,
    marginBottom: -2
  },
  mUnameTxtStyle2: {
    fontSize: 12,
    // fontFamily: 'Marker Felt, fantasy',
    // fontFamily: 'American Typewriter, serif',
    fontWeight: 600,
    marginTop: -4,
    marginBottom: 0
  },
  matchScoreNum: {
    fontSize: '26px',
    fontWeight: 700,
    fontFamily: 'Tahoma, Verdana, Segoe, sans-serif',
    // fontFamily: 'Verdana, Geneva, sans-serif',
    position: 'absolute',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    top: 25,
    textAlign: 'center',
    color: 'white',
  },
  signoutBtn: {
    marginHorizontal: 0,
    padding: 0,
  },
  signoutTxt: {
    fontSize: 14,
    margin: 3,
    marginLeft: 8,
    padding: 0,
    paddingRight: 12,
    // marginTop: 10,
    // marginBottom: 5,
    // marginRight: 5,
    textAlign: 'center',
    fontWeight: "500",
    textTransform: "none",
    // color: "#858585",
    color: "#bdbdbd",
  },
  followTxt: {
    fontSize: 14,
    margin: 3,
    // marginLeft: 15,
    padding: 0,
    // paddingRight: 12,
    textAlign: 'center',
    fontWeight: "500",
    textTransform: "none",
    color: "white",
  },
  followBlueTxt: {
    fontSize: 14,
    margin: 3,
    // marginLeft: 15,
    padding: 0,
    // paddingRight: 12,
    textAlign: 'center',
    fontWeight: "500",
    textTransform: "none",
    color: "#11b9ba",
  },
  followBtn: {
    // fontSize: 14,
    // margin: 3,
    marginLeft: 15,
    // padding: 0,
    // // paddingRight: 12,
    // textAlign: 'center',
    // fontWeight: "500",
    // textTransform: "none",
    // color: "white",
  },
  invFollowBtn: {
    // fontSize: 14,
    // margin: 3,
    marginLeft: 15,
    // padding: 0,
    // // paddingRight: 12,
    // textAlign: 'center',
    // fontWeight: "500",
    // textTransform: "none",
    opacity: 0,
  },
  logoutBtn: {
    "& span": {
      "& text": {
        color: "#858585",
        textTransform: "lowercase",
      },
    },
    "&:hover": {
      color: "#9c27b0",
    },
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
  },
  tcppTitle: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: 30,
    fontSize: 65,
    color: "#FFFFFF",
    textDecoration: "none"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  }
};

export default profilePageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/profilePage.jsx